import React from 'react';
import {
    Button, Card, CardActionArea, CardActions,
    CardContent, CardMedia, Typography
} from '@mui/material';
import { ChevronRight } from '@mui/icons-material';

const MoreInfoCard = ({ header, body, img }) => {
    return (
        <Card
            variant='outlined'
            sx={{
                maxWidth: '320px', borderRadius: '25px', maxHeight: '413px',
                backgroundColor: 'primary.body', border: '2px solid white'
            }}
        >
            <CardActionArea>
                <CardContent sx={{ padding: '15px 20px' }}>
                    <Typography
                        gutterBottom variant="h5" component="div"
                        color="primary.yorisWhite" className='font-sarala'
                    >
                        {header}
                    </Typography>
                    <Typography variant="body1" color="primary.yorisWhite" className='font-sarala'>
                        {body}
                    </Typography>
                </CardContent>
                <CardActions sx={{ padding: '5px 10px 10px 15px' }}>
                    <Button size="medium" sx={{ color: 'primary.yorisWhite' }}>See More <ChevronRight /> </Button>
                </CardActions>
                <CardMedia
                    sx={{ height: 170 }}
                    image={img}
                    title={img}
                />
            </CardActionArea>
        </Card>

    )
}

export default MoreInfoCard